// ============================================
//  TOP 成長ストーリーのホバー
// ============================================
function storyHoverImg() {
  // const mq = window.matchMedia('(min-width:1024px)');
  // const items = document.querySelectorAll('.p-index-story__item-link');
  // const setup = () => {
  //   items.forEach((item) => {
  //     if (item._on) return;
  //     const img = item.querySelector('.p-index-story__item-img');
  //     if (!img) return;
  //     let mx = 0,
  //       my = 0,
  //       cx = 0,
  //       cy = 0,
  //       raf;
  //     const speed = 0.08;
  //     const animate = () => {
  //       cx += (mx - cx) * speed;
  //       cy += (my - cy) * speed;
  //       img.style.transform = `translate(${cx}px,${cy}px)`;
  //       raf = requestAnimationFrame(animate);
  //     };
  //     const enter = (e) => {
  //       const r = item.getBoundingClientRect();
  //       const ir = img.getBoundingClientRect();
  //       let x = e.clientX - r.left - ir.width / 2;
  //       let y = e.clientY - r.top - ir.height / 2;
  //       // ▼ 横幅制限（はみ出さない）
  //       const minX = 0;
  //       const maxX = r.width - ir.width;
  //       mx = Math.max(minX, Math.min(x, maxX));
  //       my = y;
  //       cx = mx;
  //       cy = my;
  //       img.style.opacity = 1;
  //       animate();
  //     };
  //     const leave = () => {
  //       img.style.opacity = 0;
  //       cancelAnimationFrame(raf);
  //     };
  //     const move = (e) => {
  //       const r = item.getBoundingClientRect();
  //       const ir = img.getBoundingClientRect();
  //       let x = e.clientX - r.left - ir.width / 2;
  //       let y = e.clientY - r.top - ir.height / 2;
  //       // ▼ 横幅制限
  //       const minX = 500;
  //       const maxX = r.width - ir.width;
  //       mx = Math.max(minX, Math.min(x, maxX));
  //       my = y;
  //     };
  //     item.addEventListener('mouseenter', enter);
  //     item.addEventListener('mouseleave', leave);
  //     item.addEventListener('mousemove', move);
  //     item._on = () => {
  //       item.removeEventListener('mouseenter', enter);
  //       item.removeEventListener('mouseleave', leave);
  //       item.removeEventListener('mousemove', move);
  //       leave();
  //       img.style.transform = '';
  //       item._on = null;
  //     };
  //   });
  // };
  // const destroy = () => items.forEach((i) => i._on && i._on());
  // const check = () => (mq.matches ? setup() : destroy());
  // check();
  // mq.addEventListener('change', check);
}

export { storyHoverImg };
